export default __webpack_public_path__ + "static/media/12.fcae5811.png";